module.exports = __webpack_public_path__ + "static/media/vet-science.74802df8.svg";